// Core Controllers Index
// Export all reusable Stimulus controllers for use in applications
//
// Usage in consuming apps:
//   import {
//     DataTableController,
//     DatepickerController,
//     // ... etc
//   } from '@core/controllers'
//
//   application.register('data-table', DataTableController)
//   application.register('datepicker', DatepickerController)

// Data display controllers
export { default as DataTableController } from './data_table_controller'
export { default as DataTablePerPageController } from './data_table_per_page_controller'

// Form components
export { default as DatepickerController } from './datepicker_controller'
export { default as AutocompleteController } from './autocomplete_controller'
export { default as FormValidationController } from './form_validation_controller'
export { default as DependsOnController } from './depends_on_controller'
export { default as NestedFieldsController } from './nested_fields_controller'
export { default as ColorPickerController } from './color_picker_controller'
export { default as PasswordToggleController } from './password_toggle_controller'
export { default as OtpInputController } from './otp_input_controller'

// UI components
export { default as SortableController } from './sortable_controller'
export { default as TooltipController } from './tooltip_controller'
export { default as FlashController } from './flash_controller'
export { default as ModalController } from './modal_controller'
export { default as ModalAutoOpenController } from './modal_auto_open_controller'
export { default as ModalLinkController } from './modal_link_controller'
export { default as CollapseController } from './collapse_controller'
export { default as DarkModeController } from './dark_mode_controller'
export { default as FabButtonController } from './fab_button_controller'

// Clipboard/Copy utilities
export { default as CopyLinkController } from './copy_link_controller'
export { default as CodeClipboardController } from './code_clipboard_controller'

// File handling
export { default as UploaderController } from './uploader_controller'

// AJAX/Network
export { default as RemoteJsController } from './remote_js_controller'
